// actions
export const ADD_AUTH = 'ADD_AUTH';

// action creators
export const addAuth = (auth) => ({ auth, type: ADD_AUTH });
